(() => {
  const header = document.getElementById('site-navigation');
  if (!header) return;
  const menus = [...header.querySelectorAll('details')];
  const mobileMenu = header.querySelector('[data-navigation-menu]');
  const closeMenus = () => menus.forEach(menu => { menu.open = false; });
  header.addEventListener('click', event => {
    if (event.target.closest('a')) closeMenus();
  });
  document.addEventListener('click', event => {
    if (!header.contains(event.target)) closeMenus();
  });
  header.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const openMenu = event.target.closest('details[open]');
    if (!openMenu) return;
    event.preventDefault();
    openMenu.open = false;
    openMenu.querySelector('summary')?.focus();
  });
  window.matchMedia('(min-width:901px)').addEventListener('change', () => {
    if (mobileMenu) mobileMenu.open = false;
  });
  window.addEventListener('pageshow', closeMenus);
})();
